import { render, staticRenderFns } from "./Saml.vue?vue&type=template&id=35daf583&scoped=true"
import script from "./Saml.vue?vue&type=script&lang=js"
export * from "./Saml.vue?vue&type=script&lang=js"
import style0 from "./Saml.vue?vue&type=style&index=0&id=35daf583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35daf583",
  null
  
)

export default component.exports